import { API_KEY_TYPES } from "models";

export const useApiKeyTypeIdDropdownOptions = () => {
  const apiKeyTypeIdDropdownOptions = [
    { key: API_KEY_TYPES.Read, text: "Read", value: API_KEY_TYPES.Read },
    { key: API_KEY_TYPES.Write, text: "Write", value: API_KEY_TYPES.Write }
  ];
  const apiKeyTypeIdDropdownOptionsWithAll = [{ key: "all", value: 0, text: "All" }, ...apiKeyTypeIdDropdownOptions];

  return { apiKeyTypeIdDropdownOptions, apiKeyTypeIdDropdownOptionsWithAll };
};
